export default __webpack_public_path__ + "static/media/properties-empty-state.699a95b2.svg";